import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ebb64108"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "info-box"
};
const _hoisted_3 = {
  class: "item"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "种植计划：", -1));
const _hoisted_5 = {
  class: "value"
};
const _hoisted_6 = {
  class: "item"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "种植品种：", -1));
const _hoisted_8 = {
  class: "value"
};
const _hoisted_9 = {
  class: "item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "开始日期：", -1));
const _hoisted_11 = {
  class: "value"
};
const _hoisted_12 = {
  class: "item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "农事活动：", -1));
const _hoisted_14 = {
  class: "value"
};
const _hoisted_15 = {
  class: "item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "巡田记录：", -1));
const _hoisted_17 = {
  class: "value"
};
const _hoisted_18 = {
  class: "item"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "采收信息：", -1));
const _hoisted_20 = {
  class: "value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ScrollableList = _resolveComponent("ScrollableList");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_ScrollableList, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString($data.plotInfo.actionPlanVo.batch), 1)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString($data.plotInfo.actionPlanVo.plant), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString($data.plotInfo.actionPlanVo.startTime), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString($data.plotInfo.actionVo.typeLabel), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString($data.plotInfo.patrolFieldsCount) + "条", 1)]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, _toDisplayString($data.plotInfo.harvestCount) + "kg(去年11月到6月)", 1)])])]),
    _: 1
  })]);
}